import React, { forwardRef, useImperativeHandle, useState } from 'react'
import Api from '../../_helpers/Api'
import { trans } from '../../_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

function InvoiceCreditNote(props, ref) {

    const [state, setState] = useState({
        id: null,
        amount: '',
        max: null,
        maxFormatted: '',
        currency: '',
        overlay: false,
        modal: false,
        loading: false,
        onSuccess: null,
    })

    useImperativeHandle(ref, () => ({
        open: (id, max, maxFormatted, currency) => {
            handleOpen(id, max, maxFormatted, currency)
        },
        close: () => {
            handleClose()
        },
        onSuccess: fn => {
            setState(prev => ({
                ...prev,
                onSuccess: fn
            }))
        }
    }))

    const handleOpen = (id, max, maxFormatted, currency) => {

        setState(prev => ({
            ...prev,
            id: id,
            amount: maxFormatted || (max !== undefined && max !== null ? String(max) : ''),
            max: maxFormatted || (max !== undefined && max !== null ? String(max) : ''),
            maxFormatted: maxFormatted || (max !== undefined && max !== null ? String(max) : ''),
            currency: currency || '',
            overlay: true,
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                modal: true,
            }))
        }, 50)

    }

    const handleClose = e => {
        if (e) e.preventDefault()

        setState(prev => ({
            ...prev,
            id: null,
            amount: '',
            modal: false,
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                overlay: false,
            }))
        }, 50)

        if (typeof props.onClose === 'function') {
            props.onClose()
        }
    }

    const handleChange = e => {
        let value = e.target.value

        setState(prev => ({
            ...prev,
            amount: value,
        }))
    }

    const amountNumber = parseFloat(state.amount)

    const isValid = state.amount !== ''
        && !isNaN(amountNumber)
        && amountNumber > 0
        && (state.max === null || amountNumber <= state.max)

    const handleSave = () => {

        if (!isValid) return

        setState(prev => ({
            ...prev,
            loading: true,
        }))

        Api.post('invoices/create/creditnote', {
            id: state.id,
            amount: state.amount,
        }).then(res => {

            setState(prev => ({
                ...prev,
                loading: false,
            }))

            if (typeof state.onSuccess === 'function') {
                state.onSuccess(res.data)
            }

            handleClose()
        }).catch(() => {
            setState(prev => ({
                ...prev,
                loading: false,
            }))
        })
    }

    return (
        <div className={`${state.overlay ? 'visible' : ''} overlay`}>
            <div className={`${state.modal ? 'show' : ''} popup-primary medium`}>
                <div className="head-new">
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className="texts">
                        <h2>{trans('headings.creditNoteAmount')}</h2>
                        {/* <p>Попълнете необходимите данни за добавяне или редактиране на разход.</p> */}
                    </div>
                    <span className="close"></span>
                </div>

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        maxWidth: "200px",
                        margin: "0 auto",
                        marginTop: '15px',
                    }}
                >
                    <input
                        type="number"
                        min="0"
                        step="0.01"
                        max={state.max !== null ? state.max : undefined}
                        value={state.amount}
                        onChange={handleChange}
                        placeholder="0.00"
                        autoFocus
                        style={{ flex: 1, textAlign: 'right', paddingRight: '10px' }}
                    />
                    {state.max !== null &&
                        <span
                            style={{
                                whiteSpace: 'nowrap',
                                color: '#2a3e55',
                                fontSize: '14px',
                            }}
                        >
                            / {state.maxFormatted} {state.currency}
                        </span>
                    }
                </div>

                <div className="footer align-right">
                    <button onClick={handleClose}>
                        {trans('buttons.cancel')}
                    </button>
                    <button
                        className="button button-primary"
                        onClick={handleSave}
                        disabled={!isValid || state.loading}
                    >
                        {trans('buttons.confirm')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default forwardRef(InvoiceCreditNote)
